'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * @ngdoc service
 * @name $indexTauxFormat
 * @function
 *
 * @description
 * IndexTaux formatter (ie. index, marge, periodicity).
 *
 */
ngModule.factory("$indexTauxFormat", function () {
  var $indexTauxFormat = function $indexTauxFormat(indexTaux) {
    if (indexTaux == null) {
      return "-";
    }
    var formattedIndex = indexTaux.index ? indexTaux.index : "Taux fixe";
    var formattedMarge = indexTaux.marge ? " + " + indexTaux.marge : "";
    var formattedPeriodicite = indexTaux.periodicite ? " (" + indexTaux.periodicite + ")" : "";
    var formatted = formattedIndex + formattedMarge + formattedPeriodicite;
    return formatted;
  };
  return $indexTauxFormat;
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/types/index-taux/indexTauxFormat.js
// module id = 2729
// module chunks = 13